export const DEPLOYED_ENV_NAME_DEV = 'DEPLOYED_ENV_NAME_DEV';

export const DEPLOYED_ENV_NAME_UAT = 'DEPLOYED_ENV_NAME_UAT';

export const DEPLOYED_ENV_NAME_PROD = 'DEPLOYED_ENV_NAME_PROD';
